// VAMMOS sand life — official menu (bilingual EN/GR)
// Prices include VAT and all charges.
// * = Frozen product / Κατεψυγμένο προϊόν

export const menuSections = [
  {
    id: "starters",
    gr: "Ορεκτικά",
    title: { en: "Starters", gr: "Ορεκτικά" },
    time: "",
    note: { en: "The table always begins here.", gr: "Το τραπέζι πάντα ξεκινά από εδώ." },
    items: [
      { name: { en: "Eggplant dip", gr: "Μελιτζανοσαλάτα" }, price: "6,00 €" },
      { name: { en: "Tarama dip", gr: "Ταραμοσαλάτα" }, price: "7,00 €" },
      { name: { en: "Tzatziki", gr: "Τζατζίκι" }, price: "6,00 €" },
      { name: { en: "French fries", gr: "Πατάτες τηγανητές" }, price: "6,00 €" },
    ],
  },
  {
    id: "salads",
    gr: "Σαλάτες",
    title: { en: "Salads", gr: "Σαλάτες" },
    time: "",
    note: { en: "Fresh, simple, seasonal.", gr: "Φρέσκα, απλά, εποχιακά." },
    items: [
      { name: { en: "Greek salad", gr: "Χωριάτικη σαλάτα" }, price: "13,00 €" },
      { name: { en: "Cherry tomatoes with carob", gr: "Ντοματίνια με χαρούπι" }, price: "12,00 €" },
      { name: { en: "Potato salad", gr: "Πατατοσαλάτα" }, price: "7,50 €" },
    ],
  },
  {
    id: "seafood",
    gr: "Θαλασσινά",
    title: { en: "Seafood & Mains", gr: "Θαλασσινά & Κυρίως Πιάτα" },
    time: "",
    note: { en: "From the boats of the Saronic — grilled, fried, or in pasta. * = Frozen product.", gr: "Από τις βάρκες του Σαρωνικού — σχάρας, τηγανητό, ή σε ζυμαρικά. * = Κατεψυγμένο προϊόν." },
    items: [
      { name: { en: "Grilled shrimp *", gr: "Γαρίδες σχάρας *" }, price: "16,00 €" },
      { name: { en: "Fried calamari *", gr: "Καλαμάρι τηγανητό *" }, price: "14,00 €" },
      { name: { en: "Grilled sea bream", gr: "Τσιπούρα σχάρας" }, price: "18,00 €" },
      { name: { en: "Steamed mussels", gr: "Μύδια αχνιστά" }, price: "14,00 €" },
      { name: { en: "Spaghetti alle vongole *", gr: "Μακαρόνια με βόνγκολε *" }, price: "24,00 €" },
      { name: { en: "Shrimp spaghetti *", gr: "Μακαρόνια με γαρίδες *" }, price: "19,00 €" },
      { name: { en: "Shrimp orzo (kritharoto) *", gr: "Κριθαρότο με γαρίδες *" }, price: "19,00 €" },
    ],
  },
  {
    id: "softdrinks",
    gr: "Αναψυκτικά",
    title: { en: "Soft Drinks", gr: "Αναψυκτικά" },
    time: "",
    note: { en: "", gr: "" },
    items: [
      { name: { en: "Coca-Cola 330 ml (Regular / Zero / Light)", gr: "Coca-Cola 330 ml (Regular / Zero / Light)" }, price: "5,00 €" },
      { name: { en: "Fanta 250 ml (Orange / Orange Zero / Blue)", gr: "Fanta 250 ml (Πορτοκάλι / Πορτοκάλι Zero / Blue)" }, price: "5,00 €" },
      { name: { en: "Sprite 250 ml (Regular / Zero)", gr: "Sprite 250 ml (Regular / Zero)" }, price: "5,00 €" },
      { name: { en: "Avra water 1 L", gr: "Νερό Αύρα 1 L" }, price: "4,00 €" },
    ],
  },
  {
    id: "beers",
    gr: "Μπύρες",
    title: { en: "Beers", gr: "Μπύρες" },
    time: "",
    note: { en: "", gr: "" },
    items: [
      { name: { en: "Heineken, bottle 330 ml", gr: "Heineken, φιάλη 330 ml" }, price: "6,00 €" },
      { name: { en: "Heineken 0.0, bottle 330 ml", gr: "Heineken 0.0, φιάλη 330 ml" }, price: "6,00 €" },
      { name: { en: "Sol, bottle 330 ml", gr: "Sol, φιάλη 330 ml" }, price: "7,00 €" },
      { name: { en: "Fischer, bottle 330 ml", gr: "Fischer, φιάλη 330 ml" }, price: "6,00 €" },
      { name: { en: "Alfa, bottle 330 ml", gr: "Άλφα, φιάλη 330 ml" }, price: "6,00 €" },
      { name: { en: "Mamos, bottle 330 ml", gr: "Μάμος, φιάλη 330 ml" }, price: "6,00 €" },
      { name: { en: "Nymfi, bottle 330 ml", gr: "Νύμφη, φιάλη 330 ml" }, price: "6,00 €" },
      { name: { en: "Radler, bottle 330 ml", gr: "Radler, φιάλη 330 ml" }, price: "6,00 €" },
    ],
  },
  {
    id: "wines",
    gr: "Κρασιά",
    title: { en: "Wines (Bottle)", gr: "Κρασιά (Φιάλη)" },
    time: "",
    note: { en: "", gr: "" },
    items: [
      { name: { en: "Malagouzia Gerovassiliou", gr: "Μαλαγουζιά Γεροβασιλείου" }, price: "35,00 €" },
      { name: { en: "Biblia Chora", gr: "Βίβλια Χώρα" }, price: "30,00 €" },
      { name: { en: "Amuse Rosé", gr: "Amuse Rosé" }, price: "30,00 €" },
    ],
  },
  {
    id: "spirits",
    gr: "Αποστάγματα",
    title: { en: "Spirits", gr: "Αποστάγματα" },
    time: "",
    note: { en: "", gr: "" },
    items: [
      { name: { en: "Tsipouro Agioneri", gr: "Τσίπουρο Αγιονέρι" }, price: "14,00 €" },
      { name: { en: "Ouzo Varvagiannis", gr: "Ούζο Βαρβαγιάννη" }, price: "13,00 €" },
      { name: { en: "Ouzo mini", gr: "Ούζο μίνι" }, price: "12,00 €" },
      { name: { en: "Tsipouro Apostolaki", gr: "Τσίπουρο Αποστολάκη" }, price: "12,00 €" },
    ],
  },
];

// Curated highlights for the homepage
export const highlights = [
  {
    name: { en: "Grilled sea bream", gr: "Τσιπούρα σχάρας" },
    desc: { en: "Whole, charcoal-grilled with ladolemono.", gr: "Ολόκληρη, στα κάρβουνα με λαδολέμονο." },
    price: "18,00 €",
    tag: { en: "Signature", gr: "Signature" },
    section: { en: "Seafood & Mains", gr: "Θαλασσινά" },
  },
  {
    name: { en: "Spaghetti alle vongole *", gr: "Μακαρόνια με βόνγκολε *" },
    desc: { en: "Clams, garlic, white wine, olive oil, parsley.", gr: "Κοχύλια, σκόρδο, λευκό κρασί, ελαιόλαδο, μαϊντανός." },
    price: "24,00 €",
    tag: { en: "Table favourite", gr: "Αγαπημένο του τραπεζιού" },
    section: { en: "Seafood & Mains", gr: "Θαλασσινά" },
  },
  {
    name: { en: "Greek salad", gr: "Χωριάτικη σαλάτα" },
    desc: { en: "Tomato, cucumber, red onion, olives, feta, oregano, olive oil.", gr: "Ντομάτα, αγγούρι, κρεμμύδι, ελιές, φέτα, ρίγανη, ελαιόλαδο." },
    price: "13,00 €",
    tag: { en: "Classic", gr: "Κλασικό" },
    section: { en: "Salads", gr: "Σαλάτες" },
  },
  {
    name: { en: "Tarama dip", gr: "Ταραμοσαλάτα" },
    desc: { en: "House-made, whipped, served with warm bread.", gr: "Σπιτική, χτυπημένη, με ζεστό ψωμί." },
    price: "7,00 €",
    tag: { en: "To begin", gr: "Για αρχή" },
    section: { en: "Starters", gr: "Ορεκτικά" },
  },
  {
    name: { en: "Malagouzia Gerovassiliou", gr: "Μαλαγουζιά Γεροβασιλείου" },
    desc: { en: "Aromatic Greek white — stone fruit, citrus, long finish.", gr: "Αρωματικό ελληνικό λευκό — πυρηνόκαρπα, εσπεριδοειδή, μακρύ φινάλε." },
    price: "35,00 €",
    tag: { en: "Cellar pick", gr: "Επιλογή κάβας" },
    section: { en: "Wines", gr: "Κρασιά" },
  },
  {
    name: { en: "Ouzo Varvagiannis", gr: "Ούζο Βαρβαγιάννη" },
    desc: { en: "The Mytilene classic. Cold, with ice, no rush.", gr: "Ο κλασικός της Μυτιλήνης. Παγωμένο, με πάγο, χωρίς βιασύνη." },
    price: "13,00 €",
    tag: { en: "Aegean", gr: "Αιγαίο" },
    section: { en: "Spirits", gr: "Αποστάγματα" },
  },
];
